import { Contract, getAllDecodedLogs } from 'fuels';
import trainAbiJson from '../abis/train-abi.json' with { type: 'json' };
export const trainAbi = trainAbiJson;
export function buildContract(contractAddress, accountOrProvider) {
    return new Contract(contractAddress, trainAbi, accountOrProvider);
}
export function decodeTrainLogs(receipts) {
    if (!receipts?.length)
        return [];
    return getAllDecodedLogs({
        receipts,
        mainAbi: trainAbi,
    }).logs;
}
export function findUserLockedEvent(logs, hashlock) {
    for (const log of logs ?? []) {
        if (!log || typeof log !== 'object')
            continue;
        const candidate = log;
        if (!candidate.hashlock || !candidate.asset_id || candidate.user_data === undefined)
            continue;
        if (hashlock && candidate.hashlock.toLowerCase() !== hashlock.toLowerCase())
            continue;
        return candidate;
    }
    return null;
}
